import { GridActionsCellItemProps } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { PdfIcon } from 'assets/images/documents';
import { ButtonActionItem } from 'library/components/controls/datagrid/ButtonActionItem';
import { useDialogState } from 'library/hooks/useDialogState';
import { PrintProtocolDialog } from 'modules/ServiceProtocol/Components/ServiceProtocolPdf/PrintProtocolDialog';

export const ServiceProtocolPrintPdfActionItem = ({
	protocolId,
	hasActivityEvents,
	ref,
}: Pick<GridActionsCellItemProps, 'showInMenu'> & {
	protocolId: number;
	hasActivityEvents: boolean;
	ref?: React.RefObject<HTMLLIElement>;
}): React.JSX.Element => {
	const { t } = useTranslation('commonButton');
	const { handleOpen, open, handleClose } = useDialogState();

	return (
		<>
			<ButtonActionItem
				ref={ref}
				key="print"
				onClick={handleOpen}
				startIcon={<PdfIcon />}
				showInMenu
				label={t('print')}
			/>

			{open && (
				<PrintProtocolDialog
					contentProps={{ isOffline: !hasActivityEvents }}
					isOpen
					onClose={handleClose}
					id={protocolId}
				/>
			)}
		</>
	);
};
